module.exports = __webpack_public_path__ + "img/banner.2e2c0759.png";